import { render, staticRenderFns } from "./ActivitySpellingGame.vue?vue&type=template&id=6e896984&scoped=true"
import script from "./ActivitySpellingGame.vue?vue&type=script&lang=ts"
export * from "./ActivitySpellingGame.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySpellingGame.vue?vue&type=style&index=0&id=6e896984&prod&lang=scss"
import style1 from "./ActivitySpellingGame.vue?vue&type=style&index=1&id=6e896984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e896984",
  null
  
)

export default component.exports